export default __webpack_public_path__ + "static/ai-in-education2-762c902862df4fc34069b11203112283.png";